export const ResetParentalCodeEnum = {
  SUCCESS: 'success',
  FAIL: 'fail',
  START: '',
};

export const Step = {
  START: 'start',
  RESET_CODE : 'reset_code',
  ERROR: 'error',
  LOGIN: 'login',
  VERIFY_ACCOUNT: 'verify_account',
  COMPLETED_PAGE: 'completed',
}
